import { render } from "./ReceiptLines.vue?vue&type=template&id=4b51c8bf&scoped=true"
import script from "./ReceiptLines.vue?vue&type=script&lang=js"
export * from "./ReceiptLines.vue?vue&type=script&lang=js"

import "./ReceiptLines.vue?vue&type=style&index=0&id=4b51c8bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b51c8bf"]])

export default __exports__